import React, { Component } from "react";
import { DKLabel, DKButton, showAlert } from "deskera-ui-library";
import RouteManager from "../../managers/RouteManager";
import CampaignManager from "../campaign/CampaignManager";
import FormManager from "../forms/FormManager";

interface ITemplateSelectionProps {
  match: any;
  manager: any;
}

interface ITemplateSelectionState {}

class TemplateSelection extends Component<
  ITemplateSelectionProps,
  ITemplateSelectionState
> {
  manager;

  constructor(props) {
    super(props);
    this.manager = props.manager;
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    if (
      this.manager !== CampaignManager &&
      !this.manager.isPageDataAvailable() &&
      this.props.match.params.id
    ) {
      this.manager.fetchPageDataById(this.props.match.params.id);
    }
  }

  componentWillReceiveProps(
    nextProps: Readonly<ITemplateSelectionProps>,
    nextContext: any
  ) {
    this.manager = nextProps.manager;
  }

  render() {
    return (
      <div className="column parent-width flex-shrink-0">
        {this.manager.getHeader()}
        <div
          className="column p-l bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 1000, marginBottom: 100 }}
        >
          <DKLabel text="Select Template" className="fw-m fs-xl" />
          <DKLabel
            text="Select a template from below list or you can create your own template from start!"
            className="text-gray fs-m mt-s text-align-center"
          />
          <div className="row flex-wrap mt-xl justify-content-center-mobile">
              {this.getAllTemplates()}
          </div>
          <div className="row justify-content-center fixed-container-mobile ">
            <DKButton
              title={
                this.manager === FormManager
                  ? "+ Create template"
                  : "+ Blank template"
              }
              className="bg-gray2 border-m m-v-l "
              onClick={() => {
                this.manager.setSelectedTemplateId(-1);
                this.manager.navigateToBuilder();
              }}
            />
            <DKButton
              title="Proceed & Design"
              className="bg-app text-white ml-m m-v-l "
              onClick={() => {
                if (
                  this.manager.getSelectedTemplateId() === null ||
                  this.manager.getSelectedTemplateId() === undefined ||
                  this.manager.getSelectedTemplateId() === -1
                ) {
                  showAlert(
                    "Select template",
                    "Please select a template and proceed."
                  );
                } else {
                  this.manager.navigateToBuilder();
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  highlightSelection(index) {
    return this.manager.getSelectedTemplateId() !== index;
  }

  getAllTemplates() {
    let arr = [];
    (this.manager.getAllTemplates() || []).forEach((element, index) => {
      arr.push(
          <div
              className="m-m border-radius-s shadow-m border-m cursor-hand"
              style={{maxWidth: 180, height: 180}}>
            <img
                key={index}
                src={element}
                className={
                  this.highlightSelection(index)
                      ? `parent-width`
                      : `parent-width template-active`
                }
                alt=""
                onClick={() => {
                  this.manager.setSelectedTemplateId(index);
                  this.manager.navigateToBuilder();
                }}
            />
          </div>
      );
    });
    return arr;
  }
}

export default TemplateSelection;
